
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import Dropdown from "@/components/Reusable/Dropdown/Dropdown.vue";
import { Media } from "@/types/media";
import MediaPreview from "@/components/Reusable/CustomInputs/MediaInput/MediaPreview.vue";
import Icon from "@/components/UI/Icon.vue";

@Component({
  components: {
    Icon,
    MediaPreview,
    Dropdown
  }
})
export default class RepeaterItemMedia extends Vue {
  @Prop()
  media!: Media;
}
